import React from "react";
import { zl } from "../../../functions/utilities.js";

const MieszkaniecDaneWodaRozliczeniePodsumowanie = props => {
    
    const {  procent } = props;

    return (
        <div className="koszt">
            <div className="naglowek">Rozliczenie</div>
            
            <div className="podsumowanie">
                <div>
                    <table className="tabela">
                        <tbody>
                            <tr>
                                <td style={{textDecoration: "underline"}}>
                                    Łącznie naliczone zaliczki:
                                </td>
                                <td className="kwoty">
                                    {zl(procent?.zaliczka_razem)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Koszt zużycia wody:
                                </td>
                                <td className="kwoty">
                                    {zl(procent?.razemZwCwAbo)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Straty wody:
                                </td>
                                <td className="kwoty">
                                    {zl(procent?.strataMieszkancaKwota)}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    { procent?.opis }
                                </td>
                                <td className="kwoty">
                                    {zl(procent?.saldo)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    )
}

export default MieszkaniecDaneWodaRozliczeniePodsumowanie;